import React from "react";
import BlockInterface from '../editable_interface/BlockInterface/BlockInterface';
import Banner from '../components/Banner/Banner.js'
import './style.css';

export default function ExecutiveBoard() {
    /////////////////////////////////////////////////////////////////////////////
    let image_name = "exec.jpg";
    let is_video = false;
    /////////////////////////////////////////////////////////////////////////////
    return (
        <>
            <Banner src={image_name} isVideo={is_video}></Banner>
            {/* Banner aspect ration about 20:9 */}
            <BlockInterface pageName="ExecutiveBoard"></BlockInterface>
        </>
    );
}
